import React from "react"
import { UserDocument } from "popopo-msg"

export const UserInfo = (props: { user: UserDocument }) => {
  const user = props.user

  return (
    <>
      <div>
        <div>Name: {user.name}</div>
        <div>Alias: {user.alias}</div>
        <div>FriendCode: {user.friend_code}</div>
        <div>
          {user.icon_url ? (
            <>
              Icon: <img src={user.icon_url} alt="User icon" className="w-50"/>
            </>
          ) : (
            <>Icon: None</>
          )}
        </div>
      </div>
    </>
  )
}
